import "../../../App.css";
import { useTranslation } from "react-i18next";
import css from "./VKIVIU.module.css";

function HeroSectionVKIVIU() {
  const { t } = useTranslation();

  return (
    <div className={css.heroContainer}>
      <h1>{t("vkiviu_header")}</h1>
      <p>{t("vkiviu_desc")}</p>
    </div>
  );
}

export default HeroSectionVKIVIU;
